<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :model="signFrom" :label-width="80" label-postion="left">
        <Row>
          <Col span="6">
            <FormItem label="县区" :label-width="60">
              <Select v-model="signFrom.countyId" placeholder="请输入县区" @on-change="getSignReportData" clearable
                      style="width: 80%"
                      @on-clear="getSignReportData">
                <Option v-for="item in countsList" :key="item.id" :value="item.indexCode">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="签到时间" :label-width="80">
              <DatePicker type="daterange" v-model="signFrom.signTime" placeholder="选择日期"
                          @on-change="getSignReportData" clearable @on-clear="getSignReportData"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :data="SignReportData" :columns="SignReportColumns" :loading="SignReportLoading"></Table>
      <page style="padding-top: 10px;float: right"
            show-total
            show-sizer
            :current="SignReportCurrentPage"
            :page-size="SignReportPageSize"
            :total="SignReportTotal"
            :page-size-opts="pageSizeOpts"
            @on-change="currentPageChange"
            @on-page-size-change="pageSizeChange"
      ></page>
      <Button style="float: left;margin-top: 10px" type="primary" @click="downLoadSignReport"
              :loading="downloadLoading">下载
      </Button>
    </Card>
  </div>
</template>
<script>
import {columns as SignReportColumns} from "@/views/SignReport/js/colunms";

export default {
  name: 'SignReport',
  data() {
    return {
      downloadLoading: false,
      signFrom: {
        countyId: '',
        signTime: [],
      },
      SignReportData: [],
      SignReportColumns: [
        {
          title: '序号', width: 80, align: 'center',
          render: (h, params) => {
            return h('div', this.SignReportCurrentPage * this.SignReportPageSize + params.index + 1 - this.SignReportPageSize)
          }
        },
        {title: '区县名称', key: 'countyName', align: 'center'},
        {title: '签到人', key: 'signUserName', align: 'center'},
        {
          title: '签到时间', key: 'signTime', align: 'center',
          render: (h, params) => {
            return h('div', new Date(params.row.signTime).toLocaleString('chinese', {hour12: false}).replace(/\//g, '-'))
          }
        },
      ],
      SignReportLoading: false,
      SignReportCurrentPage: 1,
      SignReportTotal: 0,
      SignReportPageSize: 10,
      pageSizeOpts: [10, 20, 30, 50],
      countsList: []
    }
  },
  mounted() {
    this.getSignReportData()
    this.getCountsList()
  },
  methods: {
    downLoadSignReport() {
      this.downloadLoading = true
      let requestData = {
        countyId: this.signFrom.countyId === '' ? null : this.signFrom.countyId,
        beginDate: !this.signFrom.signTime[0] ? null : this.signFrom.signTime[0],
        endDate: !this.signFrom.signTime[1] ? null : this.signFrom.signTime[1]
      }
      let fileName = '签到报表.xlsx'
      this.$util.downloadFile(this, '/api/exportWechatSignList', fileName, requestData).then(res => {
        this.downloadLoading = false
        this.$Message.success('下载成功')
      }).catch(err => {
        this.downloadLoading = false
        this.$message.error(err)
        this.$Message.success('下载失败')
      })
    },
    // 获取下级区县
    getCountsList() {
      this.$http.get(`/api/getLowerLevelDepts`).then(res => {
        if (res.status === 200) {
          this.countsList = res.data
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getSignReportData() {
      this.SignReportLoading = true
      let requestData = {
        page: this.SignReportCurrentPage,
        size: this.SignReportPageSize,
        countyId: this.signFrom.countyId === '' ? null : this.signFrom.countyId,
        beginDate: !this.signFrom.signTime[0] ? null : this.signFrom.signTime[0],
        endDate: !this.signFrom.signTime[1] ? null : this.signFrom.signTime[1]
      }
      this.$http.post(`/api/getWechatSignRecords`, requestData).then(res => {
        if (res.status === 200) {
          this.SignReportLoading = false
          this.SignReportData = res.data.data
          this.SignReportTotal = res.data.recordsTotal
        } else {
          this.SignReportLoading = false
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.SignReportLoading = false
        this.$message.error(err)
      })
    },
    currentPageChange(page) {
      this.SignReportCurrentPage = page
      this.getSignReportData()
    },
    pageSizeChange(size) {
      this.SignReportPageSize = size
      this.getSignReportData()
    }
  }
}
</script>

<style scoped lang="less">

</style>
